import api from './api';

const vtcService = {
  requestRide: async (rideData) => {
    const response = await api.post('/vtc/rides/request', rideData);
    return response.data;
  },

  getMyRides: async () => {
    const response = await api.get('/vtc/rides/my-rides');
    return response.data;
  },

  getRide: async (id) => {
    const response = await api.get(`/vtc/rides/${id}`);
    return response.data;
  },

  cancelRide: async (id, reason) => {
    const response = await api.put(`/vtc/rides/${id}/cancel`, { cancellation_reason: reason });
    return response.data;
  },

  registerDriver: async (driverData) => {
    const response = await api.post('/vtc/drivers/register', driverData);
    return response.data;
  },

  updateAvailability: async (isAvailable) => {
    const response = await api.put('/vtc/drivers/availability', { is_available: isAvailable });
    return response.data;
  },
};

export default vtcService;
